export const SET_SEARCH_FILTER_ACTION = {
  DASHBOARD: "DASHBOARD",
  USER_LIST: "USER_LIST",
};
